var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessAnalyst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    fill: "#ffffff",
    height: 62,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "1.0 1.0 62.0 62.0",
    width: 62,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,50V62a1,1,0,0,0,1,1H40a1,1,0,0,0,1-1V50a5.006,5.006,0,0,0-5-5H34.969a5,5,0,1,0-5.938,0H28A5.006,5.006,0,0,0,23,50Zm6-9a3,3,0,1,1,3,3A3,3,0,0,1,29,41Zm3.912,11.83L32,54.2l-.912-1.367L32,49.64ZM30.674,47l-1.635,5.725a1,1,0,0,0,.129.83l2,3a1,1,0,0,0,1.664,0l2-3a1,1,0,0,0,.129-.83L33.326,47H36a3,3,0,0,1,3,3V61H25V50a3,3,0,0,1,3-3Z",
    fill: "inherit"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "change1_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.087,20.144c-.183-.669-.394-1.335-.628-1.982l-1.881.68c.216.6.411,1.212.58,1.83Z",
    fill: "inherit"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "change1_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.26,9.347c.469.432.925.889,1.359,1.357l1.468-1.358c-.469-.507-.964-1-1.472-1.469Z",
    fill: "inherit"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "change1_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.866,12.164c.393.5.773,1.021,1.126,1.553l1.665-1.108c-.384-.576-.794-1.143-1.22-1.683Z",
    fill: "inherit"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "change1_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.763,47.924l.981,1.743c.6-.34,1.2-.708,1.769-1.093L45.4,46.916C44.868,47.272,44.319,47.611,43.763,47.924Z",
    fill: "inherit"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "change1_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.491,1.234c-.684.092-1.373.214-2.048.361l.426,1.954c.623-.136,1.259-.248,1.889-.333Z",
    fill: "inherit"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "change1_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.99,15.355c.309.556.6,1.131.864,1.712l1.82-.828c-.286-.629-.6-1.254-.936-1.856Z",
    fill: "inherit"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "change1_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.78,2.52c-.648-.233-1.316-.442-1.984-.622l-.521,1.931c.616.166,1.232.359,1.83.573Z",
    fill: "inherit"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "change1_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.71,1.14,34.5,3.13c.635.066,1.274.158,1.9.274l.365-1.967C36.091,1.312,35.4,1.212,34.71,1.14Z",
    fill: "inherit"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "change1_10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.432,2.119c-.658.2-1.318.43-1.963.684l.734,1.86c.594-.234,1.2-.446,1.81-.631Z",
    fill: "inherit"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "change1_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09,29.18l1.993-.165C8.031,28.381,8,27.736,8,27.1l-2,.008C6,27.8,6.033,28.494,6.09,29.18Z",
    fill: "inherit"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "change1_12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.034,6.53c-.543-.426-1.111-.835-1.687-1.217L45.242,6.98c.532.352,1.056.731,1.557,1.124Z",
    fill: "inherit"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "change1_13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.561,42.916,50.98,41.691c-.389.5-.8,1-1.236,1.47l1.479,1.346C51.69,44,52.14,43.459,52.561,42.916Z",
    fill: "inherit"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "change1_14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3,46.711,17.16,48.353c.57.4,1.16.773,1.754,1.119l1.007-1.728C19.373,47.424,18.829,47.077,18.3,46.711Z",
    fill: "inherit"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "change1_15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.942,45.782l1.247,1.564c.542-.432,1.071-.889,1.573-1.359L48.4,44.527C47.931,44.96,47.442,45.383,46.942,45.782Z",
    fill: "inherit"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "change1_16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.288,23.272l-1.976-.309c-.106.679-.186,1.373-.238,2.065l2,.15C8.116,24.539,8.19,23.9,8.288,23.272Z",
    fill: "inherit"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "change1_17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.708,3.3l-.824,1.823c.582.263,1.159.553,1.716.861l.968-1.75C43.964,3.9,43.339,3.586,42.708,3.3Z",
    fill: "inherit"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "change1_18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.584,3.007l.058-2L32.49,1c-.641-.013-1.291,0-1.93.033l.109,2C31.259,3,31.86,2.993,32.453,3Z",
    fill: "inherit"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "change1_19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7,32.8c-.153-.617-.283-1.249-.387-1.878l-1.973.324c.112.682.253,1.367.419,2.036Z",
    fill: "inherit"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "change1_20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.773,45.552c-.493-.405-.976-.835-1.433-1.276l-1.39,1.438c.5.479,1.019.945,1.554,1.384Z",
    fill: "inherit"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "change1_21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.74,4.631l1.022,1.72c.546-.324,1.113-.632,1.687-.913l-.881-1.8C19.947,3.947,19.332,4.28,18.74,4.631Z",
    fill: "inherit"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "change1_22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.012,42.888c-.422-.477-.83-.978-1.213-1.487l-1.6,1.2c.414.553.856,1.095,1.314,1.612Z",
    fill: "inherit"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "change1_23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.709,39.822c-.341-.538-.664-1.1-.962-1.661l-1.769.933c.322.611.672,1.216,1.041,1.8Z",
    fill: "inherit"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "change1_24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.924,36.43c-.25-.584-.48-1.187-.683-1.792l-1.9.637c.22.655.469,1.309.74,1.942Z",
    fill: "inherit"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "change1_25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,3a9,9,0,1,0,9,9A9.011,9.011,0,0,0,10,3Zm0,16a7,7,0,1,1,7-7A7.008,7.008,0,0,1,10,19Z",
    fill: "inherit"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "change1_26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,10h1a.5.5,0,0,1,.5.5h2a2.5,2.5,0,0,0-2-2.449V7H9V8.051A2.5,2.5,0,0,0,9.5,13h1a.5.5,0,0,1,0,1h-1a.5.5,0,0,1-.5-.5H7a2.5,2.5,0,0,0,2,2.449V17h2V15.949A2.5,2.5,0,0,0,10.5,11h-1a.5.5,0,0,1,0-1Z",
    fill: "inherit"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "change1_27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54,22.5a9,9,0,1,0,9,9A9.011,9.011,0,0,0,54,22.5Zm0,16a7,7,0,1,1,7-7A7.008,7.008,0,0,1,54,38.5Z",
    fill: "inherit"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "change1_28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 32.5H52V34.5H50z",
    fill: "inherit"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "change1_29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 30.5H55V34.5H53z",
    fill: "inherit"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "change1_30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 28.5H58V34.5H56z",
    fill: "inherit"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "change1_31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.858,31.9l9.192-9.192L30,27.657a1,1,0,0,0,1.414,0l9.9-9.9,1.414,1.414a1,1,0,0,0,.707.293.976.976,0,0,0,.267-.036,1,1,0,0,0,.7-.721l1.414-5.657a1,1,0,0,0-1.213-1.213L38.95,13.251a1,1,0,0,0-.465,1.678L39.9,16.343l-9.193,9.193-4.95-4.95a1,1,0,0,0-1.414,0l-9.9,9.9ZM43.475,14.182l-.582,2.326-1.745-1.744Z",
    fill: "inherit"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessAnalyst);
export default __webpack_public_path__ + "static/media/business-analyst.d6e748a48e9d35077ebad68e8335fd78.svg";
export { ForwardRef as ReactComponent };